// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button_FrO-8","outline":"button_outline_3eWEZ"};